import { PrintService } from "./print.service";
import { Subscription } from "rxjs";

import { Component, Injector, OnInit, OnDestroy, Input, AfterViewInit, ApplicationRef, ComponentFactoryResolver } from "@angular/core";

import { UserService } from "../../../shared/services/user.service";
import { HttpclientService } from "../../../shared/services/httpclient.service";
import { Router, ActivatedRoute } from "@angular/router";

import { PersonSelectorService } from "../../personselector/personselector.service";
import { ConfirmationService } from "primeng/api";
@Component({
	selector: "caass-photoID-printID",
	templateUrl: "./print.component.html",
})
export class PrintComponent implements OnInit {
	// studentSelector: StudentPersonselectorComponent;
	lstStudents: any = [];
	lstStudentNotInQueue: any = [];
	selectedQueueList: any = [];
	selectedPersonList: any = [];
	componentRef: any;
	hostView: any;
	schoolID: any;
	showActionTable = false;

	AddAction = 1;
	RemoveAction = 2;
	SubmitAction = 3;
	addLoading = false;
	submitLoading = false;
	RemoveLoading = false;
	alreadyAddedInQueue = false;
	alreadyAddedInSubmittedList = false;

	personID: any;
	selectedStudent: any;
	@Input() personid: any;

	subscription: Subscription;

	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private applicationRef: ApplicationRef,
		private injector: Injector,
		private componentFactoryResolver: ComponentFactoryResolver,
		private studentService: PersonSelectorService,
		private printIDService: PrintService,
		private confirmationService: ConfirmationService
	) {}
	confirm2() {}
	ngOnInit() {
		this.subscription = this.studentService.onPersonSelectChange().subscribe((person) => {
			this.selectedStudent = person;

			//
			this.schoolID = person.SchoolID;
			this.personID = person.PersonID;
			this.StudentQueueList();
			this.StudentInSubmittedList();
			this.showActionTable = true;
		});

		// this.addStudent();
	}
	private StudentQueueList() {
		var IsSubmitted = false;
		var result = this.printIDService.StudentInQueueList(this.schoolID, IsSubmitted);

		result.subscribe(
			(response: any) => {
				this.lstStudents = response;
			},
			(error) => {}
		);
	}
	private StudentInSubmittedList() {
		var IsSubmitted = true;
		var result = this.printIDService.StudentInQueueList(this.schoolID, IsSubmitted);

		result.subscribe(
			(response: any) => {
				this.lstStudentNotInQueue = response;
			},
			(error) => {}
		);
	}
	ngOnDestroy() {
		// unsubscribe to ensure no memory leaks
		this.subscription.unsubscribe();
	}

	FadeOutLink1() {
		setTimeout(() => {
			this.alreadyAddedInQueue = false;
		}, 6000);
	}
	FadeOutLink2() {
		setTimeout(() => {
			this.alreadyAddedInSubmittedList = false;
		}, 6000);
	}
	onAddStudentInQueueClick() {
		var Array1 = this.lstStudents.map((o) => {
			return { PersonID: o.PersonID };
		});

		var Array2 = this.lstStudentNotInQueue.map((o) => {
			return { PersonID: o.PersonID };
		});

		//var student1 = Array1.indexOf(this.personID);
		//var student2 = Array2.indexOf(this.personID);
		var student = this.personID;

		var isPresentInQueue = Array1.some(function (el) {
			return el.PersonID === student;
		});
		var isPresentInDepot = Array2.some(function (ela) {
			return ela.PersonID === student;
		});

		if (isPresentInQueue || isPresentInDepot) {
			if (isPresentInQueue) {
				this.alreadyAddedInQueue = true;

				this.FadeOutLink1();
			} else if (isPresentInDepot) {
				this.alreadyAddedInSubmittedList = true;
				this.FadeOutLink2();
			}
		} else {
			this.addLoading = true;
			var newArray: any = [];
			newArray.push({ PersonID: this.personID, Command: this.AddAction });
			var result = this.printIDService.ActionOnStudentInQueueList(newArray);

			result.subscribe(
				(response: any) => {
					this.StudentQueueList();
					this.StudentInSubmittedList();
					this.addLoading = false;
					this.selectedPersonList = [];
				},
				(error) => {}
			);
		}
	}

	onSubmitClick(event: any, personID) {
		this.submitLoading = true;
		var newArray: any = [];
		newArray.push({ PersonID: personID, Command: this.SubmitAction });
		var result = this.printIDService.ActionOnStudentInQueueList(newArray);

		result.subscribe(
			(response: any) => {
				this.StudentQueueList();
				this.StudentInSubmittedList();
				this.submitLoading = false;
				this.selectedQueueList = [];
			},
			(error) => {}
		);
	}
	onRemoveClick(event: any, personID) {
		this.RemoveLoading = true;
		var newArray: any = [];
		newArray.push({ PersonID: personID, Command: this.RemoveAction });
		var result = this.printIDService.ActionOnStudentInQueueList(newArray);

		result.subscribe(
			(response: any) => {
				this.StudentQueueList();
				this.RemoveLoading = false;
				this.selectedQueueList = [];
			},
			(error) => {}
		);
	}

	onSubmitAllClick() {
		this.submitLoading = true;

		var newArray = this.lstStudents.map((o) => {
			return { PersonID: o.PersonID, Command: 3 };
		});

		var result = this.printIDService.ActionOnStudentInQueueList(newArray);

		result.subscribe(
			(response: any) => {
				this.StudentQueueList();
				this.StudentInSubmittedList();
				this.submitLoading = false;
			},
			(error) => {}
		);
	}
	onDeleteAllClick() {
		this.RemoveLoading = true;

		var newArray = this.lstStudents.map((o) => {
			return { PersonID: o.PersonID, Command: 2 };
		});

		var result = this.printIDService.ActionOnStudentInQueueList(newArray);

		result.subscribe(
			(response: any) => {
				this.StudentQueueList();
				this.StudentInSubmittedList();
				this.RemoveLoading = false;
			},
			(error) => {}
		);
	}

	public openConfirmationDialog() {
		this.confirmationService.confirm({
			message: "All students from Queue List will be removed, Do you want to continue ? ",
			header: "Remove Confirmation",
			icon: "fa fa-trash",
			accept: () => {
				this.onDeleteAllClick();
			},
			reject: () => {},
		});
	}

	onPrintClick() {
		var result = this.printIDService.printTempID(this.selectedStudent.PersonID, this.selectedStudent.SchoolID);

		result.subscribe(
			(response: any) => {
				window.open(response);
			},
			(error) => {}
		);
	}
	onPrinterClick() {
		var result = this.printIDService.printerTempID(this.selectedStudent.PersonID, this.selectedStudent.SchoolID);
		result.subscribe(
			(response: any) => {
				window.open(response);
			},
			(error) => {}
		);
	}
}
